import {useContext} from 'react'
import {Link as RouterLink, useLocation} from 'react-router-dom'
import classnames from 'classnames'

import Chip from '@mui/material/Chip'
import HomeIcon from '@mui/icons-material/HomeTwoTone';
import BadgeIcon from '@mui/icons-material/BadgeOutlined'
import PasswordIcon from '@mui/icons-material/PasswordOutlined'
import MailboxIcon from '@mui/icons-material/MarkunreadMailbox'
import PeopleIcon from '@mui/icons-material/People'
import SettingsIcon from '@mui/icons-material/SettingsSuggest'
import Link from '@mui/material/Link'
import LockIcon from '@mui/icons-material/LockOutlined'
import Stack from '@mui/material/Stack'
import TuneIcon from '@mui/icons-material/Tune'

import {NAV_OPTIONS, ADMIN_NAV_OPTIONS} from '../../lib/constants'
import {UserContext} from '../../state/contexts'
import {activePath} from '../../lib/tools'

const ICON_DICTIONARY = {
  home: HomeIcon,
  personal: BadgeIcon,
  password: PasswordIcon,
  security: LockIcon,
  invites: MailboxIcon,
  users: PeopleIcon,
  clients: SettingsIcon,
  settings: TuneIcon
}

const Nav = () => {
  const location = useLocation()
  const {mode} = useContext(UserContext)
  const navigations = mode === 'admin' ? ADMIN_NAV_OPTIONS : NAV_OPTIONS

  return (
    <Stack component='div' className='nav'>
      {
        navigations.map((option, index) => {
          const OptionIcon = ICON_DICTIONARY[option.icon.name]

          return (
            <Link 
              className={classnames(
                'nav-option',
                {
                  inactive: !activePath({
                    pathname: location.pathname,
                    basePath: navigations[0].path,
                    path: option.path}
                  )
                }
              )}
              key={index}
              component={RouterLink}
              to={option.path}>
              <Chip
                className='item'
                sx={{height: '50px', borderRadius: '25px'}}
                clickable
                icon={
                  <OptionIcon
                    fontSize='inherit'
                    color={option.icon.color}
                    sx={{backgroundColor: 'background.default', borderRadius: '30px', fontSize: '2.188rem'}}
                  />
                }
                label={option.label}
              />
            </Link>
          )
        })
      }
    </Stack>
  )
}

export default Nav
